import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { SubNav } from '../layout/submenu';

const EquipmentGroupCard = props => {
	const { selected, item, isAllowDelete, isToday, onSelect, onClickDelete } = props;
	const egReportIssue = useSelector((state) => state.equipmentGroup.EGReportIssue.list);

	const showEGReportIcon = (egId) => {
		let egIssue = egReportIssue && egReportIssue[egId] ? egReportIssue[egId] : null;
		return egIssue && !egIssue.is_resolve ?
			<i className="fa fa-exclamation-triangle mr-2" style={{ color: "red" }} title={egIssue.issue} />
			: <div></div>
	}

	return <SubNav.Item
		selected={selected}
		className="item-checkbox highlight eg-type">
		<SubNav.Card className={`${item.alive ? "" : "alive-default"}`}>
			<Row className={`p-0 m-0`}>
				<Col lg={1} md={1} sm={1} className="p-0 m-0">
					<SubNav.Checkbox
						checked={selected}
						onChange={onSelect.bind(this, item.equipment_group_uuid)}
					/>
				</Col>
				<Col lg={9} md={9} sm={9} className="p-0 m-0">
					<SubNav.Name>
						{item.equipment_group_name}
					</SubNav.Name>
				</Col>
				<Col lg={2} md={2} sm={2} className="p-0 m-0">
					{
						showEGReportIcon(item.equipment_group_uuid)
					}
					{isToday && item.alive &&
						<SubNav.ButtonGroup>
							{/* {isAllowEdit && <SubNav.EditButton onClick={this.handleEdit.bind(this, e)} />} */}
							{isAllowDelete &&
								<SubNav.DeleteButton
									onClick={onClickDelete.bind(this, item.equipment_group_uuid, item.equipment_group_name)} />}
						</SubNav.ButtonGroup>}
				</Col>
			</Row>
			{!item.vehicle.is_truck && (
				<Row className="p-0 m-0">
					<SubNav.Display2>
						{item.vehicle.name}
						{item.vehicle.name && item.implement.name && <i className="fa fa-link i-chain" aria-hidden="true" />}
						{item.implement.name && item.implement.name}
					</SubNav.Display2>
				</Row>
			)}
			<Row className="p-0 m-0">
				<SubNav.Display2>
					{item.primary_category_name && <>
						<span>
							<i className="fa fa-truck i-category" aria-hidden="true" />
							{item.primary_category_name}
						</span>
					</>}
				</SubNav.Display2>
				<SubNav.Display2>
					<div className="d-flex">
						{item.operator.name && <>
							<span>
								<i className="fa fa-user i-operator" aria-hidden="true" />
								{item.operator.name}
							</span>
						</>}
						{item.operator.name && item.phone_device.name && <SubNav.Pipe />}
						{item.phone_device.name && <>
							<span>
								<i className="fa fa-mobile i-device" aria-hidden="true" />
								{item.phone_device.name}
							</span>
						</>}
					</div>
				</SubNav.Display2>
			</Row>
			<Row className="p-0 m-0">
				<SubNav.DateRange
					start={item.start_date}
					end={item.end_date}
					alive={item.alive}
				/>
			</Row>
		</SubNav.Card>
	</SubNav.Item >;
};

export default EquipmentGroupCard;
